<mat-icon id="close" (click)="close()">close</mat-icon>
<h1>
  {{ 'SETTINGS.PREVIEW.TITLE' | translate }}
</h1>
<app-preview-send-email [emailType]="emailType"></app-preview-send-email>
<button
  class="email-preview-button"
  mat-raised-button
  color="primary"
  (click)="close()"
>
  {{ 'SETTINGS.PREVIEW.CLOSE' | translate }}
</button>
